export const NFTSTUDIOS_URI = "https://nftstudios.io/";
